
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import EllipsisLoader from "./Loader/EllipsisLoader";
import api from "../api/api";
import { useAcademicYear } from '../AcademicYearContext';
import logo from "./messiahnewlogo.jpg";
import html2pdf from "html2pdf.js";
import Autocomplete from "@mui/material/Autocomplete";
import QRCode from "qrcode";
import { jsPDF } from "jspdf";
import {
  Container,
  Typography,
  Box,
  Button,
  Modal,
  DialogActions,
  DialogTitle,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Snackbar,
  Alert,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  TablePagination,
} from "@mui/material";
import { styled } from "@mui/system";
import { Edit, Delete, Search } from "@mui/icons-material";
import { Bar } from "react-chartjs-2";
import "./StuAdm.css";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: "700px",
  maxHeight: "80%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  overflowY: "auto",
};

const Input = styled("input")({
  display: "none",
});

const emptyStudent = {
  user: "",
  full_name: "",
  gender: "",
  student_id: "",
  previous_class: "",
  grade_class: "",
  division_assigned: "",
  major_subject: "",
  previous_school: "",
  hobit: "",
  date_of_birth: "",
  address: "",
  mother_name: "",
  father_name: "",
  health_status: "",
  parent_contact: "",
  enrollment_date: "",
  semester_status: "",
  status: "",
  student_status: "",
  nationality: "",
  parent_id: "",
  academic_year: "",
};

const StudentsAdmission = () => {
  const { selectedYear } = useAcademicYear();
  const [students, setStudents] = useState([]);
  const [semesterData, setSemesterData] = useState({});
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [grades, setGrades] = useState([]);
  const [sections, setSections] = useState([]);
  const [users, setUsers] = useState([]);
  const [superParents, setSuperParents] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ message: "", severity: "" });
  const [searchTerm, setSearchTerm] = useState("");
  const [student, setStudent] = useState({ ...emptyStudent });
  const [selectedGrade, setSelectedGrade] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [semesterCount, setSemesterCount] = useState({ first_semester: 0, second_semester: 0 });
  const [genderCount, setGenderCount] = useState({ male: 0, female: 0 });

  // ---------- Helpers ----------
  const getToken = () => localStorage.getItem("access");

  const normalizeParentId = (record) => {
    if (!record) return "";
    if (typeof record.parent_id === "number") return record.parent_id;
    if (typeof record.parent_id === "string" && record.parent_id.trim() !== "") return Number(record.parent_id);
    if (typeof record.parent === "number") return record.parent;
    if (typeof record.parent === "string" && record.parent.trim() !== "") return Number(record.parent);
    if (record.parent && typeof record.parent === "object" && record.parent.id) return record.parent.id;
    return "";
  };

  // ---------- Fetch Data ----------
  useEffect(() => {
    if (selectedYear) fetchData(selectedYear.id);
  }, [selectedYear]);

  useEffect(() => {
    fetchSuperParents();
  }, []);

  useEffect(() => {
    filterStudents();
  }, [searchTerm, students]);

  useEffect(() => {
    if (editId !== null && student.parent_id) {
      // triggers render
    }
  }, [superParents, editId, student.parent_id]);

  const fetchData = async () => {
    const token = getToken();
    if (!token) {
      window.location.href = "/login";
      return;
    }
    try {
      setLoading(true);
      const config = { headers: { Authorization: `Bearer ${token}` } };

      const [studentsRes, gradesRes, sectionsRes, usersRes] = await Promise.all([
        api.get(`/api/users/students/?academic_year=${selectedYear?.id}`, config),
        api.get("/api/users/grade-classes/", config),
        api.get("/api/users/divisions/", config),
        api.get("/api/students/", config),
      ]);

      setStudents(studentsRes.data);
      setFilteredStudents(studentsRes.data);
      setGrades(gradesRes.data);
      setSections(sectionsRes.data);
      setUsers(usersRes.data.filter((u) => u.user_type === "student"));
    } catch (err) {
      setAlert({ message: err.response?.data?.detail || "Error loading data!", severity: "error" });
      if (err.response?.status === 401) {
        localStorage.removeItem("access");
        window.location.href = "/login";
      }
    } finally {
      setLoading(false);
    }
  };


///Admission start stop here///  


const generatePDF = async (student) => {
  const doc = new jsPDF("l", "pt", "a4"); // Landscape
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // ---------- HEADER ----------
  const headerY = 30;
  const logoWidth = 80;
  const logoHeight = 80;
  const logoX = 40;
  const logoBase64 = await getImageBase64FromUrl(logo);

  // Add school logo
  doc.addImage(logoBase64, "PNG", logoX, headerY, logoWidth, logoHeight);

  // School name & info (bold)
  const schoolInfoX = logoX + logoWidth + 15;
  doc.setFontSize(16);
  doc.setTextColor("#0D47A1");
  doc.setFont("helvetica", "bold");
  doc.text("Rose International Academy", schoolInfoX, headerY + 25);

  doc.setFontSize(12);
  doc.setTextColor("#0D1B2A");
  doc.setFont("helvetica", "normal");
  doc.text("Monrovia, Liberia | Contact: +231 77 021 6549 | website: https://messiahmissioninstitute.com ", schoolInfoX, headerY + 45);

  // QR Code on far right top
  const qrData = `
School: Rose International Academy
Student: ${student.full_name}
Email: ${student.email}
Password: ${student.initial_password}
Class: ${student.grade_class_name}
Division: ${student.division_assigned_name}
Parent Contact: ${student.parent_contact}
`;
  const qrCodeBase64 = await QRCode.toDataURL(qrData, { margin: 1, width: 120 });
  const qrX = pageWidth - 150;
  const qrY = headerY;
  doc.addImage(qrCodeBase64, "PNG", qrX, qrY, 120, 120);
  doc.setFontSize(10);
  doc.setTextColor("#0D1B2A");
  doc.text("Scan to view data", qrX + 60, qrY + 130, { align: "center" });

  // ---------- TITLE ----------
  doc.setFontSize(14);
  doc.setTextColor("#0D47A1");
  doc.setFont("helvetica", "bold");
  doc.text("Student Data Sheet", pageWidth / 2, headerY + logoHeight + 40, { align: "center" });

  // ---------- PROFILE IMAGE ----------
  const profileX = 40;
  let currentY = headerY + logoHeight + 60;
  const profileWidth = 120;
  const profileHeight = 120;

  if (student.profile_image) {
    const profileBase64 = await getImageBase64FromUrl(student.profile_image);
    doc.roundedRect(profileX, currentY, profileWidth, profileHeight, 10, 10, "S");
    doc.addImage(profileBase64, "JPEG", profileX, currentY, profileWidth, profileHeight);
  }

  // ---------- STUDENT INFO ----------
  const infoX = profileX + profileWidth + 30;
  const infoWidth = (pageWidth - infoX - 40 - 140) / 2; // leave space for QR code
  const lineSpacing = 16; // smaller spacing for compact readable text

  const leftColumn = [
    `Full Name: ${student.full_name}`,
    `Gender: ${student.gender}`,
    `Date of Birth: ${student.date_of_birth}`,
    `Father's Name: ${student.father_name}`,
    `Mother's Name: ${student.mother_name}`,
    `Class: ${student.grade_class_name}`,
    `Division: ${student.division_assigned_name}`,
  ];

  const rightColumn = [
    `Email: ${student.email}`,
    `Initial Password: ${student.initial_password}`,
    `Health Status: ${student.health_status}`,
    `Parent Contact: ${student.parent_contact}`,
    `Nationality: ${student.nationality}`,
    `Previous School: ${student.previous_school}`,
    `Address: ${student.address}`,
  ];

  doc.setFontSize(10);
  doc.setTextColor("#000000");
  doc.setFont("helvetica", "normal"); // normal weight for student info

  leftColumn.forEach((text, i) => {
    doc.text(text, infoX, currentY + 20 + i * lineSpacing);
  });

  rightColumn.forEach((text, i) => {
    doc.text(text, infoX + infoWidth + 20, currentY + 20 + i * lineSpacing);
  });

  // ---------- LINE SEPARATOR ----------
  currentY += profileHeight + 20;
  doc.setLineWidth(0.5);
  doc.setDrawColor("#0D1B2A");
  doc.line(40, currentY, pageWidth - 40, currentY);

  // ---------- STUDENT RULES ----------
  currentY += 20;
  doc.setFontSize(12);
  doc.setTextColor("#0D47A1");
  doc.setFont("helvetica", "bold");
  doc.text("Student Rules and Regulations", pageWidth / 2, currentY, { align: "center" });

  currentY += 20;
  doc.setFontSize(10);
  doc.setTextColor("#000000");
  doc.setFont("helvetica", "normal");

  const studentRules = `
1. Be punctual and attend school regularly.
2. Come prepared for classes and actively participate in lessons.
3. Respect the rights, dignity, and diversity of fellow students, teachers, and staff.
4. Maintain positive relationships with classmates and teachers.
5. Take care of the school�s property, resources, and facilities.
6. Follow instructions from teachers and school administration responsibly.
7. Serve as a positive role model through behavior, language, and appearance.
8. Help maintain a clean, safe, and orderly learning environment.
9. Adhere to the school�s dress code and present themselves neatly.
10. Stay informed about school announcements, policies, and events, and act accordingly.
`;

  const splitText = doc.splitTextToSize(studentRules, pageWidth - 80);
  doc.text(splitText, 40, currentY);

  // ---------- SIGNATURE ----------
  const signatureY = pageHeight - 70;
  doc.setFontSize(10);
  doc.text("Signature of Authorization: ____________________", 40, signatureY);

  // ---------- FOOTER ----------
  const footerHeight = 40;
  const bottomPadding = 10;
  doc.setFillColor("#E0E0E0");
  doc.rect(0, pageHeight - footerHeight - bottomPadding, pageWidth, footerHeight, "F");

  doc.setFontSize(10);
  doc.setTextColor("#555555");
  const footerTextY = pageHeight - footerHeight / 2 - bottomPadding / 2;
  doc.text("Polu Integrated School Management System", pageWidth / 2, footerTextY, { align: "center" });

  doc.save(`${student.full_name}_StudentData.pdf`);
};


///Admission sheet stop here///

const fetchSuperParents = async () => {
    const token = getToken();
    if (!token) return;
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const res = await api.get("/api/super-parents/", config);
      setSuperParents(res.data || []);
    } catch (err) {
      console.error("Error fetching super parents:", err);
    }
  };

  const fetchAcademicYears = async () => {
    const token = getToken();
    if (!token) return;
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const res = await api.get("/academic-years/", config);
      setAcademicYears(res.data || []);
    } catch (err) {
      console.error("Error fetching academic years:", err);
    }
  };

  useEffect(() => {
    fetchAcademicYears();
  }, []);

  const filterStudents = () => {
    setFilteredStudents(
      students.filter((s) => (s.full_name || "").toLowerCase().includes(searchTerm.toLowerCase()))
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setStudent((prev) => ({ ...prev, [name]: value }));
  };



    const getImageBase64FromUrl = async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  const handleAddOrEdit = async () => {
  const token = getToken();
  if (!token) {
    setAlert({ message: "No authentication token found!", severity: "error" });
    return;
  }
  const config = { headers: { Authorization: `Bearer ${token}` } };

  const payload = { ...student, parent: student.parent_id || null };

  try {
    setLoading(true);
    let savedStudent = student;

    if (editId) {
      const res = await api.put(`/api/users/students/${editId}/`, payload, config);
      savedStudent = res.data;
      setAlert({ message: "Student updated successfully!", severity: "success" });
    } else {
      const res = await api.post("/api/users/students/", payload, config);
      savedStudent = res.data;
      setAlert({ message: "Student added successfully!", severity: "success" });

      // ---------- Generate PDF instantly ----------
      await generatePDF(savedStudent);
    }

    fetchData();
    handleClose();
  } catch (err) {
    console.error(err);
    setAlert({ message: "Error saving student data!", severity: "error" });
  } finally {
    setLoading(false);
  }
};


  const handleDelete = async (id) => {
    const token = getToken();
    if (!token) {
      setAlert({ message: "No authentication token found!", severity: "error" });
      return;
    }
    const confirm = await Swal.fire({
      title: "Are you sure you want to delete this student?",
      text: "You will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });
    if (!confirm.isConfirmed) return;

    try {
      setLoading(true);
      const config = { headers: { Authorization: `Bearer ${token}` } };
      await api.delete(`/api/users/students/${id}/`, config);
      setAlert({ message: "Student deleted successfully!", severity: "success" });
      fetchData();
    } catch {
      setAlert({ message: "Error deleting student!", severity: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (id) => {
    const record = students.find((s) => s.id === id);
    if (!record) return;
    const normalizedParent = normalizeParentId(record);
    setStudent({ ...emptyStudent, ...record, parent_id: normalizedParent });
    setEditId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditId(null);
    setStudent({ ...emptyStudent });
  };

  const handlePageChange = (_, newPage) => setPage(newPage);
  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  // ---------- Charts (filter by selectedYear) ----------
  useEffect(() => {
    const loadCounts = async () => {
      if (!selectedYear) return;
      try {
        const token = getToken();
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const semesterRes = await api.get(`/api/students/count-by-semester/?academic_year=${selectedYear.id}`, config);
        const genderRes = await api.get(`/api/students/count-by-gender/?academic_year=${selectedYear.id}`, config);

        setSemesterCount(semesterRes.data);
        setGenderCount(genderRes.data);
      } catch (err) {
        console.error("Error loading chart data:", err);
      }
    };

    loadCounts();
  }, [selectedYear]);

  const yearlyData = {
    labels: ["1st Sem", "2nd Sem"],
    datasets: [
      {
        label: "Admissions",
        data: [semesterCount.first_semester || 0, semesterCount.second_semester || 0],
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };
  const yearlyOptions = { responsive: true, plugins: { legend: { position: "top" } } };

  const enrollmentData = {
    labels: ["Male", "Female"],
    datasets: [
      {
        label: "Gender",
        data: [genderCount.male || 0, genderCount.female || 0],
        backgroundColor: "#EEDC82",
        hoverBackgroundColor: "#CC5500",
      },
    ],
  };

  // ---------- PDF generation ----------
  const handleDownloadPDF = () => {
  if (!selectedGrade) {
    Swal.fire("Please select a Grade Class first!", "", "warning");
    return;
  }

  const studentsInGrade = students.filter(
    (s) => String(s.grade_class) === String(selectedGrade)
  );

  if (studentsInGrade.length === 0) {
    Swal.fire("No students found for this Grade Class!", "", "info");
    return;
  }

  const content = `
    <style>
      table { 
        width: 100%; 
        border-collapse: collapse; 
        font-size: 14px; 
        page-break-inside: auto; 
      }
      tr { 
        page-break-inside: avoid; 
        page-break-after: auto; 
      }
      thead { 
        display: table-header-group; 
      }
      tfoot { 
        display: table-footer-group; 
      }
      th, td { 
        border: 1px solid #000; 
        padding: 6px; 
      }
    </style>

    <div style="margin-bottom:20px;">
      <div style="display:flex; align-items:center; justify-content:center; gap:15px; text-align:center;">
        <img src="${logo}" alt="School Logo" style="width:80px; height:80px;"/>
        <div>
          <h2 style="margin:5px 0;">Messiah Mission Institute</h2>
          <p style="margin:2px 0;">Morris Farm Monrovia Liberia</p>
          <p style="margin:2px 0;">Contact: +231-770-405-998 / +231-886-484-807</p>
        </div>
      </div>
      <h3 style="margin-top:15px; text-align:center;">
        Admission Students - ${grades.find(g => g.id === Number(selectedGrade))?.name || ""}
      </h3>
    </div>

    <table>
      <thead>
        <tr style="background:#555; color:#fff; text-align:left;">
          <th>No</th>
          <th>Full Name</th>
          <th>Gender</th>
          <th>Enrollment Date</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        ${studentsInGrade
          .map((student, i) => {
            // random gray for rows
            const randomGray = Math.floor(Math.random() * 200 + 55); // 55-255 for light gray
            const bgColor = `rgb(${randomGray},${randomGray},${randomGray})`;
            const textColor = randomGray < 120 ? "#fff" : "#000";

            return `
              <tr style="background:${bgColor}; color:${textColor};">
                <td>${i + 1}</td>
                <td>${student.full_name || ""}</td>
                <td>${student.gender || ""}</td>
                <td>${student.enrollment_date || ""}</td>
                <td>${student.status || ""}</td>
              </tr>
            `;
          })
          .join("")}
      </tbody>
      <tfoot>
        <tr>
          <td colspan="5" style="text-align:center; background:#dcdcdc; color:#000; font-size:12px;">
            Polu School Management System
          </td>
        </tr>
      </tfoot>
    </table>
  `;

  const opt = {
    margin: 0.5,
    filename: `Student_Row_Call_${grades.find(g => g.id === Number(selectedGrade))?.name || "Grade"}.pdf`,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    pagebreak: { mode: ["css", "legacy"] }, // make sure page breaks respect CSS
  };

  html2pdf().from(content).set(opt).save();
};



  return (
    <div>
      <div className="admissioncontent">
        <Box padding={8}>
          <Container>
            <Typography variant="h5" align="center" gutterBottom>
              Students Admission ({selectedYear?.name || "Select Year"})
            </Typography>

        {/* ?? PDF Controls Section */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <FormControl style={{ width: "250px" }}>
          <InputLabel>Select Grade Class</InputLabel>
          <Select
            value={selectedGrade}
            onChange={(e) => setSelectedGrade(e.target.value)}
          >
            {grades.map((g) => (
              <MenuItem key={g.id} value={g.id}>
                {g.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          variant="contained"
          color="primary"
          onClick={handleDownloadPDF}
        >
          Download PDF
        </Button>
      </Box>

            <Grid container spacing={4} style={{ marginBottom: "3rem" }}>
              <Grid item xs={12} md={6}>
                <Typography variant="h5" align="center" gutterBottom>
                  Data Analysics
                </Typography>
                <Bar data={yearlyData} options={yearlyOptions} />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="h5" align="center" gutterBottom>
                  Gender Analysics
                  <Bar data={enrollmentData} />
                </Typography>
              </Grid>
            </Grid>
          </Container>

          <Snackbar
            open={!!alert.message}
            autoHideDuration={3000}
            onClose={() => setAlert({ message: "", severity: "" })}
          >
            <Alert severity={alert.severity}>{alert.message}</Alert>
          </Snackbar>

            <Box display="flex" justifyContent="space-between" marginBottom={2}>
              <TextField
                variant="outlined"
                placeholder="Search by name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                InputProps={{
                  startAdornment: <Search />,
                }}
                style={{ width: "50%" }}
              />
            </Box>

          <TableContainer component={Paper}>
            <h3>Student Admissions List</h3>
            <Table>
              <TableHead className="tableeehead">
                <TableRow>
                  <TableCell style={{ backgroundColor: "#311701ff", color: "#FFFFFF" }}>No</TableCell>
                  <TableCell style={{ backgroundColor: "#eea507ff", color: "#ffffff" }}>Name</TableCell>
                  <TableCell style={{ backgroundColor: "#311701ff", color: "#ffffff" }}>Student Session</TableCell>
                  <TableCell style={{ backgroundColor: "#eea507ff", color: "#ffffff" }}>Gender</TableCell>
                  <TableCell style={{ backgroundColor: "#311701ff", color: "#ffffff" }}>Class</TableCell>
                
                  <TableCell style={{ backgroundColor: "#eea507ff", color: "#ffffff" }}>Semester</TableCell>
                  <TableCell style={{ backgroundColor: "#0D1B2A", color: "#FFFFFF" }}>Current Status</TableCell>
                  <TableCell style={{ backgroundColor: "#eea507ff", color: "#ffffff" }}>EmD</TableCell>
                  <TableCell style={{ backgroundColor: "#311701ff", color: "#ffffff" }}>
                    <Button variant="contained" onClick={() => setOpen(true)}>Add</Button>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredStudents
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((studentRow, index) => (
                    <TableRow className="tablehover" key={index}>
                      <TableCell style={{ backgroundColor: "#0D1B2A", color: "#FFFFFF" }}>{studentRow.id}</TableCell>
                      <TableCell >{studentRow.full_name}</TableCell>
                      <TableCell>{studentRow.division_assigned_name}</TableCell>
                      <TableCell>{studentRow.gender}</TableCell>
                      <TableCell>{studentRow.grade_class_name}</TableCell>
                  
                      <TableCell>{studentRow.semester_status}</TableCell>
                      <TableCell style={{ backgroundColor: "#0D1B2A", color: "#FFFFFF" }}>{studentRow.status}</TableCell>
                      <TableCell>{studentRow.enrollment_date}</TableCell>
                      <TableCell>
                        <IconButton title="Edit Record" color="primary" onClick={() => handleEdit(studentRow.id)}>
                          <Edit className="editt" />
                        </IconButton>
                        <IconButton title="Delete Record" color="secondary" onClick={() => handleDelete(studentRow.id)}>
                          <Delete className="deletee" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            style={{ backgroundColor: "#0D1B2A", color: "#FFFFFF" }}
            component="div"
            count={filteredStudents.length}
            page={page}
            onPageChange={handlePageChange}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleRowsPerPageChange}
            rowsPerPageOptions={[5, 10, 25]}
          />

          <Modal
            open={open}
            // onClose={handleClose}
            onClose={() => {}}
            aria-labelledby="student-admission-form"
            aria-describedby="student-admission-form-description"
          >
            <Box sx={modalStyle}>
              <DialogTitle>{editId !== null ? "Edit Student" : "Add Student"}</DialogTitle>
             
                        <Grid item xs={12} sm={6}>
            <FormControl fullWidth margin="dense">
              <InputLabel>Academic Year</InputLabel>
              <Select
                label="Academic Year"
                name="academic_year"
                value={student.academic_year}
                onChange={handleInputChange}
              >
                {academicYears.map((year) => (
                  <MenuItem key={year.id} value={year.id}>
                    {year.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

              {/* Student User Autocomplete */}
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  fullWidth
                  options={users}
                  getOptionLabel={(option) =>
                    option.username || option.full_name || option.email || ""
                  }
                  isOptionEqualToValue={(o, v) => o.id === v.id}
                  value={users.find((u) => u.id === Number(student.user)) || null}
                  onChange={(_, newValue) =>
                    setStudent({ ...student, user: newValue ? newValue.id : "" })
                  }
                  PaperComponent={({ children }) => (
                    <Paper style={{ maxHeight: 200, overflowY: "auto" }}>{children}</Paper>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Student Username"
                      margin="dense"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>

              <br />

              {/* Super Parent Autocomplete */}
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  fullWidth
                  options={superParents}
                  getOptionLabel={(option) =>
                    option.username ||
                    option.full_name ||
                    option.email ||
                    ""
                  }
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  value={
                    superParents.find(
                      (sp) => sp.id === Number(student.parent_id)
                    ) || null
                  }
                  onChange={(_, newValue) =>
                    setStudent({
                      ...student,
                      parent_id: newValue ? newValue.id : "",
                    })
                  }
                  PaperComponent={({ children }) => (
                    <Paper style={{ maxHeight: 200, overflowY: "auto" }}>{children}</Paper>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Super Parent"
                      margin="dense"
                      variant="outlined"
                      placeholder="Choose Super Parent / Guardian"
                    />
                  )}
                />
              </Grid>

              <br />

              {/* Student Section */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth margin="dense">
                  <InputLabel>Student Section</InputLabel>
                  <Select
                    label="Student Section"
                    name="division_assigned"
                    value={student.division_assigned}
                    onChange={handleInputChange}
                  >
                    {sections.map((division) => (
                      <MenuItem key={division.id} value={division.id}>
                        {division.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <br />

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Full Name" variant="outlined" name="full_name" value={student.full_name} onChange={handleInputChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="County of Origin" variant="outlined" name="county_of_origin" value={student.county_of_origin} onChange={handleInputChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Previous Class" variant="outlined" name="previous_class" value={student.previous_class} onChange={handleInputChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    fullWidth
                    options={grades}
                    getOptionLabel={(option) => option.name || ""}
                    isOptionEqualToValue={(o, v) => o.id === v.id}
                    value={grades.find((g) => g.id === Number(student.grade_class)) || null}
                    onChange={(_, newValue) =>
                      setStudent({
                        ...student,
                        grade_class: newValue ? newValue.id : "",
                      })
                    }
                    PaperComponent={({ children }) => (
                      <Paper style={{ maxHeight: 200, overflowY: "auto" }}>{children}</Paper>
                    )}
                    renderInput={(params) => (
                      <TextField {...params} label="Current Class" margin="dense" variant="outlined" />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Major Subject" variant="outlined" name="major_subject" value={student.major_subject} onChange={handleInputChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Last School Attended" variant="outlined" name="previous_school" value={student.previous_school} onChange={handleInputChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Hobbit" variant="outlined" name="hobit" value={student.hobit} onChange={handleInputChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Date of Birth" variant="outlined" name="date_of_birth" type="date" InputLabelProps={{ shrink: true }} value={student.date_of_birth} onChange={handleInputChange} required />
                </Grid>
                <Grid item xs={12}>
                  <TextField fullWidth label="Student Address" variant="outlined" name="address" value={student.address} onChange={handleInputChange} />
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Gender</InputLabel>
                    <Select label="Gender" name="gender" value={student.gender} onChange={handleInputChange}>
                      <MenuItem value="Male">Male</MenuItem>
                      <MenuItem value="Female">Female</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField fullWidth label="Mother's Name" variant="outlined" name="mother_name" value={student.mother_name} onChange={handleInputChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Father's Name" variant="outlined" name="father_name" value={student.father_name} onChange={handleInputChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Health Condition" variant="outlined" name="health_status" value={student.health_status} onChange={handleInputChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Parents' Contact" variant="outlined" type="number" name="parent_contact" value={student.parent_contact} onChange={handleInputChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Enrollment Date" variant="outlined" name="enrollment_date" type="date" InputLabelProps={{ shrink: true }} value={student.enrollment_date} onChange={handleInputChange} required />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Semester</InputLabel>
                    <Select label="Semester" name="semester_status" value={student.semester_status} onChange={handleInputChange}>
                      <MenuItem value="First">First</MenuItem>
                      <MenuItem value="Second">Second</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Nationality" variant="outlined" name="nationality" value={student.nationality} onChange={handleInputChange} />
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Current Status</InputLabel>
                    <Select label="Current Status" name="status" value={student.status} onChange={handleInputChange}>
                      <MenuItem value="Pending">Pending</MenuItem>
                      <MenuItem value="Enrolled">Enrolled</MenuItem>
                      <MenuItem value="Graduated">Graduated</MenuItem>
                      <MenuItem value="Dropped">Dropped</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
 <Grid item xs={12}>
  <FormControl fullWidth>
    <InputLabel>Student Status</InputLabel>
    <Select
      label="Student Status"
      name="student_status"
      value={student.student_status}
      onChange={handleInputChange}
    >
      <MenuItem value="Regular">Regular</MenuItem>
      <MenuItem value="Dependent">Dependent</MenuItem>
      <MenuItem value="Scholarship">Scholarship</MenuItem>
    </Select>
  </FormControl>
</Grid>
              </Grid>

              {loading && (
                <Box display="flex" justifyContent="center" my={2}>
                  <EllipsisLoader autoHideDuration={4000} />
                </Box>
              )}

              <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleAddOrEdit} variant="contained" color="primary">
                  {editId !== null ? "Save Changes" : "Add Student"}
                </Button>
              </DialogActions>
            </Box>
          </Modal>
        </Box>
      </div>
    </div>
  );
};

export default StudentsAdmission;
